import Honeybadger from '@honeybadger-io/js';

export default class HoneybadgerLogger {
  init() {
    Honeybadger.configure({
      apiKey: gon.honeybadger_api_key,
      environment: 'production',
      revision: 'master',
      breadcrumbsEnabled: {
        dom: true, network: true, navigation: true, console: true
      },
      enableUncaught: true,
      enableUnhandledRejection: true
    });

    window.Honeybadger = Honeybadger;
  }
}
